import { BreakpointProps } from '@/app/features/common/common.types';
import styled from '@emotion/styled';
import { isMobile, isSmallMobile, isTablet, rem } from '@triumph/design-system';

export const ContentWrapper = styled.div<BreakpointProps>`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: ${rem(4)};
    flex-direction: row;
    flex-grow: 1;
    text-align: left;
`;

export const DocumentPreviewWrapper = styled.div<BreakpointProps>`
    display: flex;
    flex-direction: column;
    align-items: left;
    padding: ${rem(20)}
        ${({ breakpoint }) => (isTablet(breakpoint) ? rem(16) : 0)};
    gap: ${rem(16)};
    ${({ breakpoint }) => isSmallMobile(breakpoint) || 'width: fit-content'};
`;

export const FileNameDiv = styled.div`
    display: flex;
    flex-grow: 1;
`;

export const TopWrapper = styled.div<BreakpointProps>`
    display: flex;
    gap: ${rem(16)};
    align-items: flex-start;
    justify-content: center;
    width: fit-content;
`;

export const LeftWrapper = styled.div`
    width: ${rem(85)};
    height: ${rem(110)};
    background: ${({ theme }: any) => theme.colors.greyscale.white};
`;

export const RightWrapper = styled.div<BreakpointProps>`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: fit-content;
    row-gap: ${rem(16)};
`;

export const DocumentPreviewImg = styled.img`
    border: ${rem(1)} solid ${({ theme }: any) => theme.colors.link.default};
    width: ${rem(85)};
    height: ${rem(110)};
`;

export const ButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    column-gap: ${rem(16)};
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(16)};
    justify-content: center;
    padding-bottom: ${rem(15)};
    border-bottom: ${rem(1)} solid
        ${({ theme }: any) => theme.colors.greyscale.gray15};
`;

export const DocumentInfo = styled.div<BreakpointProps>`
    display: flex;
    flex-direction: ${({ breakpoint }) =>
        isMobile(breakpoint) ? 'column' : 'row'};
    justify-content: center;
    align-items: center;
    gap: ${rem(16)};
    flex-wrap: wrap;
    margin: 0 ${rem(40)};
`;

export const UploadDiv = styled.div`
    display: flex;
    flex-grow: 1;
`;
